var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Allows the user to select the origin of a fire damage affecting common areas during the qualification step.
 * touches: declaration, qualification, fireDamage
 * invariants: The selected fire cause origin is synchronized with the qualification store ; available choices are provided through configured image choices
 * inputs: qualification state, fireCauseCommonPartsOrigin, FIRE_CAUSE_COMMON_PARTS_IMAGE_CHOICES, change step
 * outputs: updates the fire damage qualification through updateQualification ; saves the qualification and moves to the next step through updateAndSaveQualification
 * see: @declaration/store/qualification, @declaration/constants/fireDamageConstants, @shared/types/api/claim
 */
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { UiButton, UiRadio } from '@claims-ia/design-system';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { FIRE_CAUSE_COMMON_PARTS_IMAGE_CHOICES, FIRE_CAUSE_COMMON_PARTS_ANSWER, } from '@declaration/constants/fireDamageConstants';
const claim = namespace('claim');
const qualification = namespace('qualification');
let FireCauseCommonPartsOriginQuestion = class FireCauseCommonPartsOriginQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.isSaving = false;
        this.typeOfDamages = '';
    }
    get fireCauseCommonPartsOriginChoices() {
        return FIRE_CAUSE_COMMON_PARTS_IMAGE_CHOICES;
    }
    get selectedValue() {
        return this.qualification.fireCauseCommonPartsOrigin;
    }
    get panelTitle() {
        return this.$tc('claim.qualification.fire_cause_extern_origin.title');
    }
    get sidebarTitle() {
        const key = 'claim.qualification.fire_cause_extern_origin.sidebar_title';
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get answer() {
        return this.qualification.fireCauseCommonPartsOrigin
            ? this.$tc(FIRE_CAUSE_COMMON_PARTS_ANSWER[this.qualification.fireCauseCommonPartsOrigin])
            : null;
    }
    get validateText() {
        return this.$tc('claim.damage.fire.button.next_step');
    }
    get uiFireCauseCommonPartsOriginChoices() {
        return this.fireCauseCommonPartsOriginChoices.map((choice) => ({
            value: choice.value,
            label: this.$tc(choice.tradKey),
            description: choice.descriptionTradKey ? this.$tc(choice.descriptionTradKey) : undefined,
            imageSrc: choice.image,
        }));
    }
    onTypeOfDamagesClick(fireCauseCommonPartsOrigin) {
        this.updateFireDamageQualification({
            qualificationPayload: {
                fireCauseCommonPartsOrigin: fireCauseCommonPartsOrigin !== this.qualification.fireCauseCommonPartsOrigin
                    ? fireCauseCommonPartsOrigin
                    : null,
            },
        });
    }
    async validate() {
        await this.updateAndSaveFireDamageQualification({
            qualificationPayload: {
                fireCauseCommonPartsOrigin: this.qualification.fireCauseCommonPartsOrigin,
            },
            step: this.step,
        });
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], FireCauseCommonPartsOriginQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], FireCauseCommonPartsOriginQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateQualification')
], FireCauseCommonPartsOriginQuestion.prototype, "updateFireDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], FireCauseCommonPartsOriginQuestion.prototype, "updateAndSaveFireDamageQualification", void 0);
FireCauseCommonPartsOriginQuestion = __decorate([
    Component({
        components: { QuestionPanel, UiRadio, UiButton },
        props: QuestionProps,
    })
], FireCauseCommonPartsOriginQuestion);
export default FireCauseCommonPartsOriginQuestion;
